export const UPDATE_AGENT_STATE = 'UPDATE_AGENT_STATE';

export const AGENTS_LOADING = 'AGENTS_LOADING';
export const AGENTS_LOADED = 'AGENTS_LOADED';
export const AGENTS_LOAD_ERROR = 'AGENTS_LOAD_ERROR';

export const NEW_AGENTS_ADDING = 'NEW_AGENTS_ADDING';
export const NEW_AGENTS_ADDED = 'NEW_AGENTS_ADDED';
export const NEW_AGENTS_ADDITION_ERROR = 'NEW_AGENTS_ADDITION_ERROR';

export const AGENT_PROFILE_DETAILS_LOADING = 'AGENT_PROFILE_DETAILS_LOADING';
export const AGENT_PROFILE_DETAILS_LOADED = 'AGENT_PROFILE_DETAILS_LOADED';
export const AGENT_PROFILE_DETAILS_LOAD_ERROR = 'AGENT_PROFILE_DETAILS_LOAD_ERROR';

export const AGENT_UPDATED = 'AGENT_UPDATED';
export const AGENT_DELETED = 'AGENT_DELETED';

export const GROUPS_LOADING = 'GROUPS_LOADING';
export const GROUPS_LOADED = 'GROUPS_LOADED';
export const GROUPS_LOAD_ERROR = 'GROUPS_LOAD_ERROR';
export const GROUP_DELETED = 'GROUP_DELETED';

export const CANNED_RESPONSES_LOADING = 'CANNED_RESPONSES_LOADING';
export const CANNED_RESPONSES_LOADED = 'CANNED_RESPONSES_LOADED';
export const CANNED_RESPONSES_LOAD_ERROR = 'CANNED_RESPONSES_LOAD_ERROR';
export const CANNED_RESPONSE_DELETED = 'CANNED_RESPONSE_DELETED';
export const CANNED_RESPONSE_UPDATED = 'CANNED_RESPONSE_UPDATED';
export const CANNED_RESPONSE_CREATED = 'CANNED_RESPONSE_CREATED';

//--------------------------------- SOCKET ACTIONS ----------------------------------

export const MAKE_MEMBER_PAGE_SOCKET_CONNECTION = 'MAKE_MEMBER_PAGE_SOCKET_CONNECTION';
export const MEMBER_SOCKET_DISCONNECT = 'MEMBER_SOCKET_DISCONNECT';
export const UPDATE_TRANSFER_CHAT_DATA = 'UPDATE_TRANSFER_CHAT_DATA';
export const LOAD_AGENT_LIST_FOR_SELECTED_GROUP = 'LOAD_AGENT_LIST_FOR_SELECTED_GROUP';
export const AGENT_AVAILABILITY_UPDATE = 'AGENT_AVAILABILITY_UPDATE';
export const EMIT_MEMBER_CUSTOM_EVENT = 'EMIT_MEMBER_CUSTOM_EVENT';

//--------------------------------- TAG ACTIONS ----------------------------------

export const TAGS_LOADING = 'TAGS_LOADING';
export const TAGS_LOADED = 'TAGS_LOADED';
export const TAGS_LOAD_ERROR = 'TAGS_LOAD_ERROR';

export const TAG_CREATED = 'TAG_CREATED';
export const TAG_UPDATED = 'TAG_UPDATED';
export const TAG_DELETED = 'TAG_DELETED';



// WEBPACK FOOTER //
// ./src/data/redux/member_details/actiontypes.js